import { SerializedWidget } from '../Widget'
import { emptyDashboard } from './OrionStorage'

let globals = window;

let lsFunctions = globals => ({
  getFromLS: function (id) {
    let ls = {};
    if (globals.localStorage) {
      ls = JSON.parse(globals.localStorage.getItem(id));
    }
    return ls;
  },
  saveToLS: function(id, key, value) {
    if (globals.localStorage) {
      let config = this.getFromLS(id) || {};
      config[key] = value;
      globals.localStorage.setItem(
        id, JSON.stringify(config)
      );
    }
  },
  remove: function(key){
    if (globals.localStorage) {
      globals.localStorage.removeItem(key);
    }
  }
});

let defaultResolved = fn => setTimeout(fn, 1000);

class LocalStorage {
  constructor(id, {resolver, defaultLayout} = {}) {
    this.id = id;
    this.widgets = "widgets";
    this.layouts = "layouts";
    this.lsFunctions = lsFunctions(globals);
    this.resolver =  resolver || defaultResolved;
    this.defaultLayout = defaultLayout || emptyDashboard;
  }

  saveLayout(layout) {
    this.lsFunctions.saveToLS(this.id, this.layouts, layout);
  }

  saveWidgets(widgets) {
    let names = widgets.map(w => {
      let name = (w.className || w);
      return new SerializedWidget(w.id, name);
    });
    this.lsFunctions.saveToLS(this.id, this.widgets, names);
  }

  save(dashboard) {
    return new Promise((resolve, reject) => {
      try {
        this.resolver(() => {
          this.saveWidgets(dashboard.widgets);
          this.saveLayout(dashboard.layouts);
          resolve(true)
        })
      } catch (e) {
        reject(e);
      }
    })
  }

  load() {
    let fromLS = this.lsFunctions.getFromLS(this.id) || {};
    let layouts = fromLS[this.layouts] || this.defaultLayout.layouts;
    let widgets = fromLS[this.widgets] || this.defaultLayout.widgets;
    return new Promise((resolve, reject) => {
      this.resolver(() => {
        resolve({
          layouts, widgets
        })
      })
    })
  }
  //Non part of the standard storage interface
  delete() {
    this.lsFunctions.remove(this.id);
  }
  equals(other) {
    return other && other.id && other.id === this.id;
  }
}

export { defaultResolved };
export default LocalStorage;
